import { useEffect, useState } from "react";
import Button from '../../../components/button/button';
import Label from '../../../components/label/label';
import Input from '../../../components/input/input';
import { useSettings } from "../../../hooks/useSettings";

function Customers() {
    const [show, setShow] = useState(true);
    const [edit, setEdit] = useState(false);
    const [customerNumberStart, setCustomerNumberStart] = useState('');
    const [customerStatusList, setCustomerStatusList] = useState([]);
    const { fetchData, data, saveCustomerData } = useSettings();

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (edit && data) {
            setCustomerNumberStart(data.customerNumberStart || '');
            setCustomerStatusList(
                Array.isArray(data.customerStatusList) && data.customerStatusList.length > 0
                    ? data.customerStatusList
                    : ['Neu', 'In Verhandlung', 'Kunde']
            );
        }
    }, [edit, data]);

    const handleEdit = () => {
        setEdit(true);
        setShow(false);
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setEdit(false);
        setShow(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const normalizedStatuses = customerStatusList
            .map((status) => status.trim())
            .filter(Boolean);

        await saveCustomerData(e, customerNumberStart.trim(), normalizedStatuses);

        setEdit(false);
        setShow(true);
    };

    const handleStatusChange = (index, value) => {
        setCustomerStatusList((prev) => {
            const next = [...prev];
            next[index] = value;
            return next;
        });
    };

    const handleAddStatus = () => {
        setCustomerStatusList((prev) => [...prev, '']);
    };

    const handleRemoveStatus = (index) => {
        setCustomerStatusList((prev) => prev.filter((_, statusIndex) => statusIndex !== index));
    };

    const statuses = Array.isArray(data?.customerStatusList) ? data.customerStatusList : [];

    return (
        <div>
            {show && (
                <>
                    <p>Kundennummer Start: {data?.customerNumberStart || '-'}</p>
                    <div style={{marginBottom: '16px'}}>
                        <p>Verfügbare Kundenstatusliste:</p>
                        {statuses.length > 0 ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                {statuses.map((status) => (
                                    <span
                                        key={status}
                                        style={{ border: '1px solid #ccc', borderRadius: '999px', padding: '4px 10px' }}
                                    >
                                        {status}
                                    </span>
                                ))}
                            </div>
                        ) : (
                            <p>Keine Stati hinterlegt.</p>
                        )}
                    </div>
                    <Button buttonValue='Bearbeiten' onClick={handleEdit} />
                </>
            )}
            {edit && (
                <form onSubmit={handleSubmit}>
                    <Label labelFor='customerNumberStart' labelValue='Kundennummer Start: ' />
                    <Input
                        inputId='customerNumberStart'
                        borderColor='black'
                        inputValue={customerNumberStart}
                        onChange={(e) => setCustomerNumberStart(e.target.value)}
                    />
                    <div style={{ marginTop: '16px' }}>
                        <Label labelFor='customerStatusList' labelValue='Kundenstatusliste: ' />
                        {customerStatusList.map((status, index) => (
                            <div key={`customer-status-${index}`} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <Input
                                    inputId={`customerStatus-${index}`}
                                    borderColor='black'
                                    inputValue={status}
                                    onChange={(e) => handleStatusChange(index, e.target.value)}
                                />
                                <Button buttonType='button' buttonValue='Entfernen' onClick={() => handleRemoveStatus(index)} />
                            </div>
                        ))}
                        <Button buttonType='button' buttonValue='Status hinzufügen' onClick={handleAddStatus} />
                    </div>
                    <br />
                    <Button buttonType='button' buttonValue='Abbrechen' onClick={handleCancel} />
                    <Button buttonType='submit' buttonValue='Speichern' />
                </form>
            )}
        </div>
    );
}

export default Customers;